import { createReportDetailsRoute } from '@/router/utils';
import { handleTranslations, } from '@/layouts/_components/Notifications/_util/notification-factory';
import { getFullName } from '@/util/user';
export const handleAnsweredRequiredActionMessage = (notification) => {
    const { type, payload: { brand, user, report }, } = notification;
    return {
        getTranslations() {
            const translationPlaceholders = {
                ...report,
                user: getFullName(user),
            };
            return handleTranslations(type, translationPlaceholders);
        },
        getRoute() {
            return createReportDetailsRoute(brand.id, report.id);
        },
    };
};
